// Copyright 2025, University of Maryland, All Rights Reserved
import type { NodeApiClient } from '@/app-shell/services'
import type { KbSchema, KnowledgeBaseResponse } from '../types'

export async function fetchKnowledgeBase(client: NodeApiClient, basePath: string): Promise<KnowledgeBaseResponse | null> {
  const { data } = await client.get<KnowledgeBaseResponse | null>(`${basePath}/knowledge-base`)
  return data ?? null
}

export async function fetchKbSchema(client: NodeApiClient, schemaId: string): Promise<KbSchema | null> {
  const { data } = await client.get<KbSchema | null>(
    `/knowledge_base/schemas/${encodeURIComponent(schemaId)}`,
  )
  return data ?? null
}

export interface CreateItemApiPayload {
  content: string
  score: number | null
  metadata?: Record<string, unknown>
  fields?: Record<string, string> | null
}

export interface UpdateItemApiPayload {
  content: string
  score: number | null
  metadata?: Record<string, unknown>
  fields?: Record<string, string> | null
}

export async function createItem(
  client: NodeApiClient,
  basePath: string,
  payload: CreateItemApiPayload,
) {
  await client.post(`${basePath}/items`, payload)
}

export async function updateItem(
  client: NodeApiClient,
  basePath: string,
  id: string,
  payload: UpdateItemApiPayload,
) {
  await client.put(`${basePath}/items/${id}`, payload)
}

export async function deleteItem(client: NodeApiClient, basePath: string, id: string) {
  await client.delete(`${basePath}/items/${id}`)
}
